module.exports = __webpack_public_path__ + "img/36000.a61378ce.jpg";